<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>CUENTAS</span>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" lg="6" xl="4" class="pa-2 pb-0">
        <v-select
          :items="[
            { text: 'Cuenta de Gastos', value: 'Gastos' },
            { text: 'Cuenta de Recursos', value: 'Recursos' },
            { text: 'Cuenta Contable de Gastos', value: 'Contable Gastos' },
            { text: 'Cuenta Contable de Recursos', value: 'Contable Recursos' },
          ]"
          label="Tipo de Cuenta"
          item-text="text"
          item-value="value"
          v-model="tiposPartidas"
          outlined
          dense
          hide-details
          multiple
          small-chips
          clearable
          @change="onHandleChangeTiposPartidas" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn
          small
          color="primary"
          class="mr-2"
          @click="$refs.modalFormPartidaRef.abrir('registrar', [])"
          title="Registrar">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null"
          @click="$refs.modalFormPartidaRef.abrir('editar', item)"
          title="Editar">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null"
          @click="() => confirmacionAccion(accionesAConfirmar.ELIMINAR, `${item.codigo} ${item.nombre}`)"
          title="Eliminar">
          <v-icon>mdi-close</v-icon>

          Eliminar
        </v-btn>

        <v-btn class="mr-2" small color="secondary" @click="$refs.modalImportarCuentasRef.abrir()" title="Importar">
          <v-icon>mdi-file-import</v-icon>

          Importar
        </v-btn>

        <v-btn small class="mr-2" @click="listar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-4">
        <ListadoPartida ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormPartida ref="modalFormPartidaRef" :nombreRecurso="nombreRecurso" @actualizarListado="listar" />

    <ModalFormularioImportarCuentas ref="modalImportarCuentasRef" @importado="listar" />

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoPartida from './../views/ListadoPartida.vue';
import ModalFormPartida from './../components/ModalFormPartida.vue';
import ClasificadorServices from './../services/clasificador';
import LayoutMixin from '../mixins/layout-mixin';
import ModalFormularioImportarCuentas from '../components/ModalFormularioImportarCuentas.vue';

export default {
  name: 'ClasificadorLayout',
  mixins: [LayoutMixin],
  components: {
    ListadoPartida,
    ModalFormPartida,
    ModalFormularioImportarCuentas,
  },
  data() {
    return {
      servicioListarItems: ClasificadorServices.findAllFiltros,
      nombreRecurso: 'CUENTA',
      tiposPartidas: JSON.parse(localStorage.getItem('tipos_partidas')) || [],
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      const params = {
        tipos_partidas: this.tiposPartidas,
      };

      this.listarMixin(params);
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await ClasificadorServices.destroy(this.item.id);
      }

      return response;
    },
    onHandleChangeTiposPartidas() {
      localStorage.setItem('tipos_partidas', JSON.stringify(this.tiposPartidas));

      this.listar();
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>